import React from 'react'
import styled from 'styled-components'
import breakpoint from 'styled-components-breakpoint'
import TitleBar from '../title-bar'
import Wrapper from '../layout/Wrapper'
import ReactSVG from 'react-svg'
import GridDeTarjetas from '../tarjetas/grid-de-tarjetas'

const ItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;

  ${breakpoint('tablet')`
    flex-direction: row;
		margin-left: -10px;
    margin-right: -10px;
    margin-bottom: 40px;
	`}
`

const Item = styled.button`
  flex: 1 1;
  flex-flow: row nowrap;
  width: 100%;
  display: flex;
  align-items: center;

  text-align: left;
  cursor: pointer;
  transition: all 0.5s;
  align-items: center;
  box-sizing: border-box;
  padding: 5px;
  background: #fff;
  font-size: 14px;
  border: solid 1px ${props => props.theme.colors.grisMedio};
  margin-top: -1px;
  z-index: 1;

  ${breakpoint('tablet')`
		flex-basis: 14.7%;
		flex-flow: column nowrap;
		margin: 0 10px;
    font-size: 0.8em;
    max-width: 150px;
    flex: 1;
    text-align: center;
    padding: 20px 20px 15px;
    border-radius: 5px;
  `}

  & > div {
    flex: none;
    margin-right: 15px;

    ${breakpoint('tablet')`
      margin-bottom: 8px;
      margin-right: 0;

    `}
  }

  & > span {
    display: block;
    flex: 1;
  }

  .svg-icon path,
  .svg-icon rect,
  .svg-icon polygon {
    transition: fill 0.5s ease, color 0.5s ease;
  }

  &:hover {
    transform: translateY(-4px);
    box-shadow: 1px 3px 6px 0 rgba(0, 0, 0, 0.3);
    border-color: ${props => props.theme.colors.rojoBac};
    color: ${props => props.theme.colors.rojoBac};

    .svg-icon path,
    .svg-icon rect,
    .svg-icon polygon {
      fill: ${props => props.theme.colors.rojoBac};
    }
  }

  svg {
    width: 30px;
    display: block;
    margin: 0 auto;
    pointer-events: none;

    ${breakpoint('tablet')`
      width: 60px;
    `}
  }

  &:active,
  &:focus {
    outline: 0;
  }

  &.selected {
    border-color: ${props => props.theme.colors.rojoBac};
    color: ${props => props.theme.colors.rojoBac};
    z-index: 2;

    .svg-icon path,
    .svg-icon rect,
    .svg-icon polygon {
      fill: ${props => props.theme.colors.rojoBac};
    }
  }
`

class IconsSection extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      selectedCategory: this.props.items[0].node.titulo || null,
    }
    this.selectCategory = this.selectCategory.bind(this)
  }

  selectCategory(e, category) {
    e.preventDefault()
    this.setState({ selectedCategory: category })
  }

  render() {
    const {
      title,
      subtitle,
      items,
      tarjetas,
      countryAbr,
      whatsapp,
      formUrl,
      multicanalidad,
    } = this.props
    const selectedCategory = this.state.selectedCategory
    const categoryCards = tarjetas.filter(t =>
      t.node.categorias.map(z => z.titulo).includes(selectedCategory)
    )

    return (
      <>
        <TitleBar title={title} subtitle={subtitle} />
        <Wrapper>
          <ItemsContainer>
            {items.map(item => (
              <Item
                key={item.node.id}
                className={
                  selectedCategory === item.node.titulo ? 'selected' : ''
                }
                onClick={e => this.selectCategory(e, item.node.titulo)}
              >
                <ReactSVG
                  path={item.node.icono.file.url}
                  className="svg-icon"
                />
                <span>{item.node.titulo}</span>
              </Item>
            ))}
          </ItemsContainer>
        </Wrapper>

        <GridDeTarjetas
          tarjetas={categoryCards.map(t => t.node)}
          countryAbr={countryAbr}
          whatsapp={whatsapp}
          formUrl={formUrl || null}
          multicanalidad={multicanalidad}
        />
      </>
    )
  }
}

export default IconsSection
